import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { trackSuiteEvent } from "shared/util/track";
import BookDemoModal from "components/demo/BookDemoModal";

const BookDemoSection = ({ eventName = "Book a Demo Call" }) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const handleClick = () => {
    trackSuiteEvent(eventName, "button_click");
    setModalOpen(true);
  };

  return (
    <div className="book-demo-section">
      <p>{t("auth.wantLiveWalkthrough")}</p>
      <button type="button" className="book-demo-button" onClick={handleClick}>
        {t("auth.bookDemoCall")}
      </button>
      <BookDemoModal show={modalOpen} onClose={() => setModalOpen(false)} trigger={eventName} />
    </div>
  );
};

export default BookDemoSection;
